export const CLoggerConstants = {
  applicationName: 'Roller.Checkout',
  logSizeLimit: 100,
  logFlushInterval: 10000,
  pageID: 1 // required for logs to be submitted
};
